export default "__VITE_ASSET__0EFRrLVp__"